import React from 'react';
import PropTypes from 'prop-types';
import { TeamIcon } from 'common/react/components/TeamIcon';
import { TeamWatermarkBackground } from 'widgets/statspro/js/components/TeamWatermarkBackground';

/**
 * Renders the team header section.
 *
 * @param {object} props    - The props.
 * @returns {React.JSX.Element}   - The formatted team header section.
 */
export const TeamAnnouncementsHeader = (props) => {
    const teamAbbreviation = PULSE.app.common.team.getTeamAbbr(props?.clubId);

    return (
        <div className={`team-announcements__header ${teamAbbreviation}`}>
            <TeamIcon
                className="team-announcements__header-club-logo"
                theme="light"
                providerId={props?.clubId}
            />
            <h3 className="team-announcements__header-title">{props.name}</h3>
            {props?.clubId ? (
                <TeamWatermarkBackground
                    className="team-announcements__header-club-watermark"
                    side="right"
                    type="colour"
                    providerId={props?.clubId}
                />
            ) : null}
        </div>
    );
};

TeamAnnouncementsHeader.propTypes = {
    clubId: PropTypes.string,
    name: PropTypes.string
};
